window._ = require('lodash');

// try {
// window.$ = window.jQuery = require('jquery');
//dependencies
// } catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Codeigniter back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
const apiURL = document.head.querySelector('meta[name="api-url"]');
// const awsURL = document.head.querySelector('meta[name="aws-url"]');
const source = document.head.querySelector('meta[name="booking-source"]')
const captchaSiteKey = document.head.querySelector('meta[name="recaptcha-sitekey"]')
window.bookingSource = source.content;
window.recaptchaKey = captchaSiteKey.content;
window.axios.defaults.baseURL = apiURL.content;
window.axios.defaults.params = {};
window.axios.defaults.params['source'] = window.bookingSource;
// window.axios.defaults.baseURL = 'https://pokeapi.co/api/v2/';
/**
 * Make sure to call `loadStripe` outside of a component’s render to avoid
 * recreating the `Stripe` object on every render.
 */


/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

// let token = document.head.querySelector('meta[name="csrf-token"]');
//
// if (token) {
//     window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
// } else {
//     console.error('CSRF token not found');
// }
//Import Semantic UI CSS
// import 'semantic-ui-css/semantic.min.css';